import React from "react";
//#region types
import { BusinessUnitFormTypes } from "models/formTypes";
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
import { BusinessUnitListViewContainerProps } from "models/propTypes/businessUnitPropTypes";
//#endregion
//#region components
import { Skeletons, useFilterContext } from "components/common";
import { TimeLogsFormContainer } from "components/timeReporting";
import { useTimeReportingService, useBusinessUnitService } from "serviceHooks";
//#endregion
import { CompanyService } from "services";

const BusinessUnitListViewContainer: React.FC<BusinessUnitListViewContainerProps> = (props) => {
  const timeReportingService = useTimeReportingService();
  const businessUnitService = useBusinessUnitService();

  const { filter } = useFilterContext<BusinessUnitFormTypes.Filter>();
  const [reportData, setReportData] = React.useState<ApiModel.TimeReportingReportRow[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { businessUnitId, reloadKey } = props;

  React.useEffect(() => {
    if (filter) {
      setIsLoading(true);
      fetchReportData();
    }
  }, [filter, reloadKey]);

  const onlyBusinessUnits = businessUnitService.isBusinessUnitsEnabled() && !CompanyService.isTimeReportingEnabled();

  const fetchReportData = () => {
    timeReportingService
      .getReport({
        ...filter,
        businessUnitId,
        includeOnlyDeviations: onlyBusinessUnits,
      })
      .then((res) => {
        setReportData(res.data ?? []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onTimeLogsChange = (updatedRows: ApiModel.TimeReportingReportRow[]) => {
    setReportData(updatedRows);
  };

  return isLoading ? (
    <Skeletons.FormSkeleton></Skeletons.FormSkeleton>
  ) : (
    <TimeLogsFormContainer
      dataRows={reportData}
      onTimeReportRowsChange={onTimeLogsChange}
      allowCheckBoxSelection={false}
      hiddenColumns={
        onlyBusinessUnits
          ? [
              "hoursToInvoice",
              "commentsCount",
              "projectTime",
              "internalProjectTime",
              "hourlyRate",
              "calculatedAmount",
              "invoicedAmount",
              "timeReportInvoiceStatus",
              "utilizationRate",
            ]
          : ["hoursToInvoice"]
      }
      compactTable={true}
      onlyBusinessUnits={onlyBusinessUnits}
    ></TimeLogsFormContainer>
  );
};

export default BusinessUnitListViewContainer;
